<template>
  <div>
    <div v-if="show" :class="classNames" v-on:click="onHeadlineClick(id)">
      ...
    </div>
    <div v-else>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    getProps: Function,
    showButton: Function,
  },

  data: function() {
    const { id, headline, onClick } = this.getProps();
    const isButton = _.isFunction(onClick);

    return {
      is_show: false,
      id,
      headline,
      onClick,
      isButton,
      classNames: {
        'button': isButton
      },
    }
  },
  computed: {
    show() {
      const row = this.getProps();
      return row.method == 3;
    }
  },
  methods: {
    onHeadlineClick: function(id) {
      if (this.isButton) {
        this.onClick(id);
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .button {
    outline: 0;
    border-color: #9999;
    margin: 0.5em 0;
    background: #fff;
    border-radius: 5px;
    color: #000;
    font-family: "Quicksand", sans-serif;
    font-size: 1em;
    font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    transition: 0.3s;
    padding: 0px 15px 23px 14px;
    height: 16px;

    &:hover {
      background: #ec9148;
      color: #fff;
    }
  }
</style>